import { makeStyles } from 'tss-react/mui';

import { dFlex } from '@assets/mixins';

const useStyles = makeStyles()((theme) => ({
  box: {
    ...dFlex(),
    gap: 8,
    color: theme.palette.custom.text.dark,

    '& .MuiSvgIcon-root': {
      color: theme.palette.custom.text.dark,
      width: 18,
    },
  },
  row: {
    ...dFlex('unset', 'unset'),
    position: 'relative',
  },
}));

export default useStyles;
